import { render, staticRenderFns } from "./tableSqlConfig.vue?vue&type=template&id=d4d90c50"
import script from "./tableSqlConfig.vue?vue&type=script&lang=js"
export * from "./tableSqlConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports